var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speaker"},[_c('ImgComponent',{staticClass:"speaker-img",attrs:{"head_img":_vm.data.head_img,"width":"500","height":"500"}}),_c('span',{staticClass:"speaker-title"},[_vm._v(_vm._s(_vm.data.title))]),_c('span',{staticClass:"speaker-description"},[_vm._v(_vm._s(_vm.data.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }